import { PageContainerProps } from '../utils/props';
import tailwindClassNames from '../utils/tailwindClassNames';

export default function PageContainer({ className, children }: PageContainerProps) {
  return <div className={tailwindClassNames('w-full pl-6 pr-6 lg:pl-6 p-6', className ?? '')}>{children}</div>;
}
